import { render, staticRenderFns } from "./ProjectStaffInfo.vue?vue&type=template&id=7f7ffbcb&scoped=true&"
import script from "./ProjectStaffInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectStaffInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ffbcb",
  null
  
)

export default component.exports